module.exports = __webpack_public_path__ + "img/shopify.c71f6c3e.svg";